import { TextField, TextFieldProps } from "../TextField/TextField";

import ReactInputMask from "react-input-mask";

type MaskedTextFieldProps = TextFieldProps & {
  mask: string;
};
export const MaskedTextField = (
  { value, onChange, mask, ...rest }: MaskedTextFieldProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) => {
  return (
    <ReactInputMask
      mask={mask}
      value={value}
      onChange={onChange}
      maskPlaceholder={null}
      inputRef={ref}
    >
      <TextField {...rest} />
    </ReactInputMask>
  );
};
